import React, {Component} from 'react';
import {removeClassFromBody} from "../../utils/utils";
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import {connect} from "react-redux";
import {getWarehouse, getWarehouses} from "../../store/actions/warehouse";
import PropTypes from "prop-types";
import {getBooks} from "../../store/actions/book";
import * as roles from "../../utils/userRoles";
import Modal from "react-modal";
import AddBooking from "../../components/popups/AddBooking";
import EditBooking from "../../components/popups/EditBooking";
import {toast} from "react-toastify";

BigCalendar.momentLocalizer(moment);
Modal.setAppElement('#root');

const calendarViews = ['month', 'day'];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    removeClassFromBody('auth-page');
    this.state = {
      selectedWarehouseId: '',
      resourceMap: [],
      books: [],
      addModalIsOpen: false,
      editModalIsOpen: false,
      view: calendarViews[0],
      date: new Date(),
      slotInfo: null
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    this.props.getWarehouses();
  }

  componentWillReceiveProps(nextProps) {
    if (!!nextProps.warehouses.length) {
      let {resourceMap, books} = this.state;

      if (nextProps.books) {
        books = nextProps.books;
      }

      this.setState({
        resourceMap,
        books: this.convertBooksToEvents(books)
      });
    }
  }

  convertDocksToResource(docks) {
    return docks.map(dock => ({
      resourceId: dock.id,
      resourceTitle: dock.name
    }));
  }

  handleWarehouseChange(ev) {
    const selectedWarehouseId = ev.target.value;
    const selectedWarehouse = this.getWarehouse(selectedWarehouseId);
    const resourceMap = !!selectedWarehouseId ? this.convertDocksToResource(selectedWarehouse.warehouse_docks) : [];
    let {books} = this.state;

    if (!!selectedWarehouseId) {
      this.props.getBooks(selectedWarehouseId);
    } else {
      books = [];
    }


    this.setState({
      selectedWarehouseId,
      resourceMap,
      books
    });
  }

  getWarehouse(warehouseId) {
    return this.props.warehouses.filter(wh => wh.id === parseInt(warehouseId, 10))[0];
  }

  convertBooksToEvents(books) {
    return books.map(book => ({
      ...book,
      id: book.id,
      title: `${book.po_number} - ${book.truck_number}`,
      start: new Date(book.start_date),
      end: new Date(book.end_date),
      resourceId: book.dock,
      user: book.user
    }));
  }

  openModal(slotInfo = null, action) {
    let {addModalIsOpen, editModalIsOpen} = this.state;

    switch (action) {
      case 'add':
        addModalIsOpen = true;
        break;
      case 'edit':
        editModalIsOpen = true;
        break;
      default:
        break;
    }

    this.setState({
      addModalIsOpen,
      editModalIsOpen,
      slotInfo
    });
  }

  closeModal() {
    this.setState({
      addModalIsOpen: false,
      editModalIsOpen: false
    });
  }

  onSelectSlot(slotInfo) {
    const {role} = this.props.user;
    const {view, selectedWarehouseId} = this.state;

    if (view === 'week' || view === 'month') {
      this.setState({
        view: 'day',
        date: slotInfo.slots[0]
      });

      return;
    }

    if (!selectedWarehouseId && role === 'general') {
      toast.error('Select warehouse', {
        position: toast.POSITION.TOP_RIGHT,
        className: ''
      });

      return;
    }

    if (role === roles.GENERAL_USER) {
      this.openModal(slotInfo, 'add');
    }
  }

  handleViewChange(view) {
    this.setState({
      view
    });
  }

  handleDateChange(date) {
    this.setState({
      date
    });
  }

  getEventProps(event) {
    return {
      className: !event.responded ? 'requested' : event.user === this.props.user.id ? 'my-booking' : null
    };
  }

  onSelectEvent(event) {
    const {user} = this.props;
    if (user.id !== event.user || user.role !== 'general') {
      return;
    }

    this.openModal(event, 'edit');
  }

  render() {
    const {resourceMap, books, addModalIsOpen, view, date, slotInfo, selectedWarehouseId, editModalIsOpen} = this.state;
    const {warehouses} = this.props;
    const warehousesList = (
        <select className="form-control" name="warehouse" id="warehouse" value={selectedWarehouseId}
                onChange={this.handleWarehouseChange.bind(this)}>
          <option value="">--Select Warehouse--</option>
          {warehouses.map(warehouse => (
              <option key={warehouse.id} value={warehouse.id}>{warehouse.name}</option>))}
        </select>
    );

    return (
        <main>
          <div className="container dashboard">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h2>Bookings</h2>
                    <div className="form-group inline m-0">
                      <label htmlFor="city">Warehouse</label>
                      {warehousesList}
                    </div>
                  </div>
                  <div className="card-body">
                    <BigCalendar
                        selectable
                        events={books}
                        resources={resourceMap}
                        resourceIdAccessor="resourceId"
                        resourceTitleAccessor="resourceTitle"
                        views={calendarViews}
                        popup={true}
                        onSelectSlot={this.onSelectSlot.bind(this)}
                        view={view}
                        onView={this.handleViewChange.bind(this)}
                        date={date}
                        onNavigate={this.handleDateChange.bind(this)}
                        onSlotSelect={this.onSelectSlot.bind(this)}
                        eventPropGetter={this.getEventProps.bind(this)}
                        onSelectEvent={this.onSelectEvent.bind(this)}
                        timeslots={1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Popups*/}
          <Modal isOpen={addModalIsOpen} onRequestClose={this.closeModal}>
            <AddBooking onModalClose={this.closeModal} slotInfo={slotInfo}/>
          </Modal>
          <Modal isOpen={editModalIsOpen} onRequestClose={this.closeModal}>
            <EditBooking onModalClose={this.closeModal} eventInfo={slotInfo}
                         warehouse={warehouses.filter(wh => wh.id === parseInt(selectedWarehouseId, 10))[0]}/>
          </Modal>
        </main>
    );
  }
}

Dashboard.propTypes = {
  getWarehouses: PropTypes.func.isRequired,
  getWarehouse: PropTypes.func.isRequired,
  warehouses: PropTypes.array,
  getBooks: PropTypes.func.isRequired,
  books: PropTypes.array
};

Dashboard.defaultProps = {
  warehouses: []
};

const mapDispatchToProps = dispatch => ({
  getWarehouses: () => dispatch(getWarehouses()),
  getWarehouse: id => dispatch(getWarehouse(id)),
  getBooks: warehouseId => dispatch(getBooks(warehouseId))
});

const mapStateToProps = state => ({
  warehouses: state.warehouse.warehouses,
  books: state.book.books,
  user: state.auth.user
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.jsx